// issuer-logout-bounce.ts - commit the top-level navigation that ends the hosted
// issuer's browser session (the Better Auth cookie on auth.bounded.sh).
//
// The issuer cookie is SameSite=Lax, so only a TOP-LEVEL navigation carries it:
// a credentialed fetch or a hidden iframe cannot end that session. Assigning
// `window.location.href` only QUEUES that navigation, though. logout() used to
// resolve immediately after the assignment, so a caller that navigated again
// right away - `await logout(); location.reload()` is the dashboard's exact
// sign-out handler - replaced the still-pending bounce: the issuer cookie
// survived and the next social login silently signed the "signed-out" account
// straight back in.
//
// The fix is simply to NOT resolve while the navigation is in flight. A
// successful navigation destroys this document, so the caller never resumes and
// can never cancel the bounce; the timer exists only so a navigation that never
// commits (e.g. a user declining a `beforeunload` dialog) cannot hang the caller
// forever. Local session state is already cleared before this runs, so resuming
// on that fallback still leaves the app fully logged out.
//
// Verified in a real browser: with an immediate resolve the tab stays on the
// caller's page (bounce lost); holding until the document is destroyed lands on
// the issuer.
/** Navigate to the issuer /logout bounce. The returned promise stays pending
 *  while the navigation is in flight - a successful navigation tears down this
 *  document instead of resolving it - and settles only via `capMs` if the
 *  navigation never commits. */
export function commitIssuerLogoutBounce(bounce, capMs = 15000) {
    return new Promise((resolve) => {
        setTimeout(resolve, capMs);
        window.location.href = bounce;
    });
}
